/**
 * BREADCRUMB TOKENS
 */
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createBreadcrumbTokens(s: SemanticTokens) {
  return {
    base: {
      gap: s.layout.gap.sm, // --breadcrumb-base-gap: var(--spacing-8)
      itemGap: s.layout.gap.xs, // --breadcrumb-base-item-gap: var(--spacing-4)
      fontSize: s.typography.fontSize.sm, // --breadcrumb-base-font-size
      lineHeight: s.typography.lineHeight.lg, // --breadcrumb-base-line-height
      iconSize: '0.625rem', // --breadcrumb-base-icon-size
      lastItemFontWeight: s.typography.fontWeight.bold, // --breadcrumb-last-item-font-weight
    },
    fg: s.text.secondary, // --breadcrumb-fg: var(--text-secondary)
    fgHover: s.text.secondary, // --breadcrumb-fg-hover: var(--text-secondary)
    iconFg: s.text.secondary, // --breadcrumb-icon-fg: var(--text-secondary)
    iconFgHover: s.text.secondary, // --breadcrumb-icon-fg-hover: var(--text-secondary)
    separatorFg: s.text.muted, // --breadcrumb-separator-fg: var(--text-muted)
  };
}
export const breadcrumbTokens = createBreadcrumbTokens(SEMANTIC);
